import { getTimeSimplifiedDurationFn, useCadencedTime, VariableValue } from '@timeflies/app-ui';
import React from 'react';
export var TimeCounter = function (_a) {
    var startTime = _a.startTime, duration = _a.duration, colored = _a.colored;
    return (startTime
        ? React.createElement(InnerTimeCounter, { startTime: startTime, duration: duration, colored: colored })
        : React.createElement(VariableValue, { variableName: 'actionTime', value: duration, colored: colored }));
};
var InnerTimeCounter = function (_a) {
    var startTime = _a.startTime, duration = _a.duration, colored = _a.colored;
    var timeSimplifiedDurationFn = React.useMemo(function () { return getTimeSimplifiedDurationFn({ startTime: startTime, duration: duration }, 2); }, [startTime, duration]);
    var value = useCadencedTime(timeSimplifiedDurationFn);
    return React.createElement(VariableValue, { variableName: 'actionTime', value: value, colored: colored });
};
